/**
 * Wrapper Routes are routes that inject company and me into the loader data.
 *
 */
export const wrapperRoutes = ["routes/s.$company"];
